import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList as List } from 'react-window';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import InfiniteLoader from 'react-window-infinite-loader';
import styles from '../Discount.module.less';
import Loading from '../../../components/Loading/Loading';
import { getDiscountRankList, getDiscountRankMenu } from '../../../actions/discount';
import DiscountHead from '../../../components/Discount/DiscountRank/DiscountHead';
import DiscountCard from '../../../components/Discount/DiscountRank/DiscountCard';
import _LogInView from '../../../components/_LogInView/_LogInView';
import { logging, logPostInfo } from '../../../actions/log';
import rankListDefault from '../../../static/discount/rank_list_default.png';
import ScrollTopWhite from '../../../components/ScrollTopWhite/ScrollTopWhite';

const selectRankList = createSelector(
  state => state.discount,
  discount => discount.rankAppList,
);

const selectRankType = createSelector(
  state => state.discount,
  discount => discount.selectType,
);

const selectRankOrder = createSelector(
  state => state.discount,
  discount => discount.selectOrder,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function DiscountRank() {
  const dispatch = useDispatch();
  // 页面的宽高，用于传入组件使用
  const [nodeStyle, setNodestyle] = useState({ width: 880, height: 600 });
  const [showNum, setShowNum] = useState(2);
  const [el, setEl] = useState(null);
  const rankList = useSelector(selectRankList);
  const [showData, setShowData] = useState([]);
  const listNodeRef = useRef(null);
  const rankListNode = useRef(null);
  const rankType = useSelector(selectRankType);
  const rankOrder = useSelector(selectRankOrder);
  const [initTime, setInitTime] = useState(Date.now());
  const logInfoData = useSelector(selectLogInfo);

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Sales_Rank`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Sales_Rank',
        label: '',
        param2: {
          source: 'Sales_Rank',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Sales_Rank',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, []);

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });
  useActivate(() => {
    pagePvLog();
  });
  useEffect(() => {
    pagePvLog();
  }, []);

  useEffect(() => {
    dispatch(getDiscountRankMenu());
  }, []);

  // useEffect(() => {
  //   dispatch(getDiscountRankMenu());
  //   setInitTime(+new Date());
  //   dispatch(
  //     logPostInfo({
  //       source: 'Sales_Rank',
  //       source_p: logInfoData.source_p,
  //       source_pp: logInfoData.source_pp,
  //     }),
  //   );
  // }, []);

  // useActivate(() => {
  //   setInitTime(+new Date());
  // });
  // useUnactivate(() => {
  //   getUVlog();
  // });

  // const getUVlog = () => {
  //   dispatch(
  //     logging({
  //       category: 'I',
  //       action: 'View_Time',
  //       label: '',
  //       param2: {
  //         source: 'Sales_Rank',
  //         source_p: logInfoData.source_p,
  //         source_pp: logInfoData.source_pp,
  //         initTime: initTime,
  //         leaveTime: Date.now(),
  //         time: Math.ceil(Date.now() - initTime),
  //       },
  //     }),
  //   );
  // };

  useEffect(() => {
    dispatch(
      getDiscountRankList({ type: rankType, order: rankOrder, pageCursor: '', refresh: true }),
    );
  }, [rankType, rankOrder]);

  // 让每次resize的时候，重新根据每一行的高度计算列表展示数据
  useEffect(() => {
    if (showData?.length > 0 && listNodeRef?.current && listNodeRef.current.resetAfterIndex) {
      showData.forEach((_, i) => listNodeRef.current.resetAfterIndex(i));
      // 控制横向出滚动条
      if (listNodeRef.current._outerRef) {
        listNodeRef.current._outerRef.style[`overflow`] = 'hidden';
        listNodeRef.current._outerRef.style[`overflow-y`] = 'overlay';
      }
    }
  }, [showData, nodeStyle, listNodeRef]);

  useEffect(() => {
    switch (showNum) {
      case 2:
        setShowData(rankList.list2);
        break;
      case 3:
        setShowData(rankList.list3);
        break;
      case 4:
        setShowData(rankList.list4);
        break;
    }
  }, [showNum, rankList, rankType, rankOrder]);

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(() => {
    const clientWidth = (document.body && document.body.clientWidth) ?? 1060;
    const clientHeight = (document.body && document.body.clientHeight) ?? 680;
    let width = 180 + 10;
    let height = 170;
    if (clientWidth >= 1060 && clientWidth < 1370) {
      setShowNum(2);
    } else if (clientWidth >= 1370 && clientWidth < 1750) {
      setShowNum(3);
    } else if (clientWidth >= 1750) {
      setShowNum(4);
    }
    setNodestyle({
      width: clientWidth > 1920 ? 1920 - width : clientWidth - width,
      height: clientHeight - height,
    });
  }, []);

  const Row = useCallback(
    ({ index, style }) => {
      return (
        <div className={styles.row_content}>
          <div
            style={{
              ...style,
              // width: `calc(100% - 66px)`,
              height: '154px',
              // paddingLeft: '40px',
              // paddingRight: '26px',
              marginBottom: `25px`,
              display: `grid`,
            }}
            className={styles.rank_list}
          >
            {showData[index].map((item, i) => {
              return (
                <_LogInView
                  logInfo={{
                    logAction: 'Sales_Detail',
                    type: item?.type,
                    id: item?.id,
                    source: 'Sales_Rank',
                  }}
                  cardData={item}
                  key={i}
                >
                  <DiscountCard soft={item} />
                </_LogInView>
              );
            })}
          </div>
        </div>
      );
    },
    [showNum, showData],
  );

  const loadMore = () => {
    if (rankList?.pageCursor) {
      dispatch(
        getDiscountRankList({
          type: rankType,
          order: rankOrder,
          pageCursor: rankList?.pageCursor,
          refresh: false,
        }),
      );
    }
  };

  return (
    <div className={styles.discount_rank}>
      <DiscountHead />
      {rankList.loading && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
      {!rankList.loading && (
        <>
          {showData?.length > 0 && (
            <div className="discount_rank_list" ref={rankListNode}>
              <InfiniteLoader
                isItemLoaded={index => {
                  return !!showData[index];
                }}
                itemCount={10000}
                loadMoreItems={loadMore}
              >
                {({ onItemsRendered, ref }) => {
                  return (
                    <List
                      height={nodeStyle.height}
                      itemCount={showData?.length}
                      itemSize={146}
                      // width={nodeStyle.width}
                      onItemsRendered={onItemsRendered}
                      ref={list => {
                        ref(list);
                        listNodeRef.current = list;
                      }}
                    >
                      {Row}
                    </List>
                  );
                }}
              </InfiniteLoader>
            </div>
          )}
          {showData?.length === 0 && (
            <div className={styles.rank_list_default}>
              <img src={rankListDefault} />
              <span>商品持续上架中</span>
            </div>
          )}
          <div className={styles.scoll_control}>
            <ScrollTopWhite node={rankListNode.current?.querySelector('div')} quickly={true} />
          </div>
        </>
      )}
    </div>
  );
}

export default () => (
  <KeepAlive name="discountRank">
    <DiscountRank />
  </KeepAlive>
);
